import React, { createContext, useContext } from 'react';
import useMemberTraits, { MemberTraitFields } from '@src/hooks/useMemberTraits';
import { MemberTraits } from '@src/graphql/home/queries/memberTraits';

interface MemberTraitsContextInterface {
  memberTraits?: MemberTraits;
  loading?: boolean;
  error?: any;
}

const MemberTraitsContext = createContext<MemberTraitsContextInterface>({
  memberTraits: undefined,
});

const MemberTraitsProvider: React.FC = ({ children }) => {
  const memberTraitFields: MemberTraitFields[] = [
    MemberTraitFields.HasApplications,
    MemberTraitFields.HasApprovedApplications,
    MemberTraitFields.HasBachelorsWarning,
    MemberTraitFields.HasBookmarks,
    MemberTraitFields.HasCoachRecommendations,
    MemberTraitFields.HasCompletedApplications,
    MemberTraitFields.HasDeferredApplications,
    MemberTraitFields.HasQuizRecommendations,
    MemberTraitFields.HasReferrals,
    MemberTraitFields.HasStartedApplications,
    MemberTraitFields.IsCurrentlyEnrolled,
    MemberTraitFields.IsCurrentlyEnrolledInEcornell,
    MemberTraitFields.IsTransitionMember,
    MemberTraitFields.IsUnsureAboutNextStep,
    MemberTraitFields.TransitionProgram,
  ];
  const { error, loading, memberTraits } = useMemberTraits(memberTraitFields);

  return (
    <MemberTraitsContext.Provider
      value={{
        error,
        loading,
        memberTraits,
      }}
    >
      {children}
    </MemberTraitsContext.Provider>
  );
};

const useMemberTraitsContext = () => useContext(MemberTraitsContext);

export default MemberTraitsProvider;

export {
  useMemberTraitsContext,
  MemberTraitsContext,
  MemberTraitsProvider,
  MemberTraitsContextInterface,
};
